export { default as wrapRootElement } from './src/styles/redux-wrapper';
require('./src/styles/prism-override.css');
